$shm_hitalama_tasks $shm_hitalama_taskmanager
	menu_title \Задачи
